/** 컬러 상수 — 아래 값만 수정하면 전체 배경·폰트 색상이 반영됩니다. */
export const COLORS = {
  /** 기본 본문·테두리 (진한 초록) */
  textPrimary: '#2d4a2d',
  /** 강조 텍스트·아이콘 (하트, 음악 버튼 등) */
  textAccent: '#4a9c4a',
  /** 보조 강조 (D-day 숫자 등) */
  textAccentLight: '#6aab6a',

  /** 섹션 기본 배경 */
  bgDefault: '#ffffff',
  /** 교차 섹션 배경 (연한 연두) */
  bgAlt: '#f4faf4',
  /** 푸터·호버 등 강조 배경 */
  bgAccent: '#b8e0b0',

  /** 결혼식 당일 사진 업로드 전용 색상 */
  photoUploadBg: '#fff1f5',
  photoUploadText: '#633747',
  photoUploadButton: '#a94f6b',
  photoUploadButtonText: '#ffffff',

  /** 연두 계열 단계 (밝음 → 진함) */
  accent50: '#eef8ee',
  accent100: '#e0f2dc',
  accent200: '#c8e6c0',
  accent300: '#a8d9a0',
  accent400: '#8fcf85',
  accent500: '#b8e0b0',
  accent600: '#7bc96f',

  /** 테두리 */
  borderPrimary: '#2d4a2d',
  borderAccent: '#a8d5a2',
  borderNeutral: '#b3acac',
  borderLight: '#c2bebe',
  borderLighter: '#ccc8c8',

  /** 장식선 */
  lineMuted: '#8aab8a',
  lineAccent: '#6aab6a',

  /** 캘린더 하트 오버레이 */
  heartOverlay: 'rgba(74, 156, 74, 0.42)',

  /** 모달·오버레이 */
  modalBg: '#fefefe',
  overlay: 'rgba(0, 0, 0, 0.3)',
  copyBtn: '#c5dcc0',

  /** 유틸리티 */
  error: '#f44336',
  groom: '#49bfee',
  bride: '#7bc96f',
  textMuted: '#b4afaf',
  textMutedDark: '#a19e9e',
};
